import { Component, OnInit, Input } from '@angular/core';
import { privacyLinks } from 'src/app/core/constants/constants';

@Component({
	selector: 'molla-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {	

	@Input() containerClass = "container";
	@Input() isBottomSticky = false;

	currentYear: any;	

	privacyLinks = privacyLinks;

	constructor() {
	}

	ngOnInit(): void {
		this.currentYear = (new Date()).getFullYear();
	}
}
